import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-faire_academy_likedislike_chapter_click-click';

/**
 * Tracks on click of the like/dislike of the individual chapter pages, for Faire Academy
 */
export function trackOpenWithFaireFaireAcademyLikedislikeChapterClickClick(
  UserState_string: string,
  GuideName_string2: string,
  ChapterName_string3: string,
  IsLike_boolean4: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      UserState_string,
      GuideName_string2,
      ChapterName_string3,
      IsLike_boolean4,
    },
  });
}
